import { Component, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OopsCategory } from 'src/app/core/components/categories/oops-category.model';
import { SecurityGroupSecurityModel } from 'src/app/core/models/security-model/security-group-security.model';
import { SecurityGroupService } from 'src/app/core/services/system-services/security-group.service';
import { ActionBarHandlerModel, ActionbarService, ACTION_STATUS } from 'src/app/shared/ui/actionbar';
import { CancelButtonModel, CopyButtonModel, NewButtonModel, RefreshButtonModel } from 'src/app/shared/ui/actionbar/models';
import { NavigationService } from 'src/app/shared/utils/navigation';
import { PAGE_TITLE } from '../../../settings-management-content/shared/title-constant';

@Component({
    selector: 'op-news-content',
    templateUrl: './news-content.component.html',
    providers: [ActionbarService],
})
export class NewsContentComponent implements OnInit {
    private readonly NEWS_SECURITY_CODE = 'NEWS';

    private readonly SEARCH_TABID = 'SEARCH';
    private previousTitle: string = PAGE_TITLE.settings;
    private defaultTitle = PAGE_TITLE.news;
    public title: string = this.defaultTitle;
    public selectedItem: OopsCategory;
    private unsubscribe$ = new Subject();
    public selectedTab: string;
    public userSecurity = {} as SecurityGroupSecurityModel;

    private _navigationSubscription: Subscription;

    actionBarHandler = new ActionBarHandlerModel(
        new NewButtonModel(),
        new CopyButtonModel(),
        new CancelButtonModel(),
        new RefreshButtonModel() 
    );

    constructor(private navigationService: NavigationService,
        private actionbarService: ActionbarService,
        private securityGroupService: SecurityGroupService) {}

    ngOnInit(): void {
        let param = this.navigationService.getParams();
        if (param?.redirectToSetting) {
            this.back();
        }
        this.selectedTab = this.SEARCH_TABID;       
        this.getUserSecurity();
    }

    ngAfterViewInit(): void {
        this.actionbarService.updateState(this.actionBarHandler);
        this.actionbarService.action$.pipe(takeUntil(this.unsubscribe$)).subscribe(actionId => {
            this.toolbarClicked(actionId);
        });
    }

    ngOnDestroy(): void {
        if (this._navigationSubscription) {
            this._navigationSubscription.unsubscribe();
        }
        this.unsubscribe$.next();
        this.unsubscribe$.unsubscribe();
    }

    toolbarClicked(e: string) {
        if (e == ACTION_STATUS.back) {
            this.back();
        }
    }

    back() {
        let param = {}
        this.navigationService.navigate('/main/settings/home', this.previousTitle, null, param);
    }

    private getUserSecurity() {
        this.securityGroupService.getUserSecurityGroupSecurity()
            .subscribe(
                (response: SecurityGroupSecurityModel[]) => {
                    let index = response.findIndex(item => item.securityCode == this.NEWS_SECURITY_CODE);
                    Object.assign(this.userSecurity, response[index]);
                    if (index != -1) {
                        this.setupSecurity();
                    }
                }
            )
    }

    private setupSecurity() {
        if (this.userSecurity?.newFlag == false) {
            this.actionBarHandler.get(ACTION_STATUS.new).disable();
        }
        if (this.userSecurity?.copyFlag == false) {
            this.actionBarHandler.get(ACTION_STATUS.copy).disable();
        }
    }
}
